import { render, staticRenderFns } from "./DonationFormSection.vue?vue&type=template&id=268ca3e4&"
import script from "./DonationFormSection.vue?vue&type=script&lang=ts&"
export * from "./DonationFormSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports